// Enum for trip request payment methods
export const PaymentType = Object.freeze({
  CARD: 'card',
  TICKETS: 'tickets',
  PAY_ON_BOARD: 'pay_on_board',
  SMART_CARD: 'smart_card',
  PASS: 'pass',
  PAY_WITH_NEW_CARD: 'payWithNewCard'
});
